import { Button } from '@affine/component';

import * as styles from './following-status-bar.css';

/** The bar while the viewer follows someone who leads, with the button that stops it. */
export function FollowingStatusView({
  status,
  stopLabel,
  onStop,
  testId = 'following-status-bar',
}: {
  status: string;
  stopLabel: string;
  onStop: () => void;
  testId?: string;
}) {
  return (
    <div className={styles.root} data-testid={testId}>
      <div className={styles.statusText}>
        <span className={styles.pulsingDot} />
        <span className={styles.presenterName}>{status}</span>
      </div>
      <Button
        variant="secondary"
        className={styles.stopButton}
        onClick={onStop}
      >
        {stopLabel}
      </Button>
    </div>
  );
}
